import { useEffect, useState } from 'react';

import { getCurrentWhiteLabel, subscribeWhiteLabel } from '@/utils/infrastructure/whiteLabel';

/**
 * Read the brand currently painted by `whiteLabel.js` and re-render whenever it
 * is resolved again (login, company switch, logout).
 */
export default function useWhiteLabel() {
  const [snapshot, setSnapshot] = useState(getCurrentWhiteLabel);

  useEffect(() => subscribeWhiteLabel(setSnapshot), []);

  return snapshot;
}
